
import { Autocomplete, Checkbox, TextField } from "@mui/material";

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export interface IMultiSelectOptions {
    label: string;
    value: string;
}

interface IProps {
    selectedList: Array<IMultiSelectOptions>;
    optionsList: Array<IMultiSelectOptions>;
    labelledBy?: string;
    onChangeEvent: (selectedList: any, list: any) => void;
    hasSelectAll?: boolean;
};

export const MultiSelect = (props: IProps) => {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    return (
        <Autocomplete
            multiple
            isOptionEqualToValue={(option, value) => option.value === value.value}
            size='small'
            getOptionLabel={(option) => option.label}
            options={props.optionsList || []}
            defaultValue={props.selectedList || []}
            onChange={props.onChangeEvent}
            renderOption={(props, option, { selected }) => (
                <li {...props}>
                    <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    {option.label}
                </li>
            )}
            renderInput={(params) => (
                <TextField {...params} />
            )}
        />
    );
};
